module.exports = __webpack_public_path__ + "img/plcconfig_shebeicanshu.5e5d9756.png";